import React, { useCallback, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { ENDPOINTS } from "@/config/endpoints";
import axios from "axios";
import { useRouter } from "next/router";
// import enIN from "@/locales/common/enIN";
import esMX from "@/locales/common/esMX";
import enUS from "@/locales/common/enUS";

const schema = (t) => {
  return yup.object({
    Company: yup.string().required(t.MexicoFormFieldsLabels.commonError),
    Email: yup
      .string()
      .required(t.MexicoFormFieldsLabels.commonError)
      .email(t.MexicoFormFieldsLabels.emailNotValid)
      .restrictedEmail(t.MexicoFormFieldsLabels.restrictEmail),
    Phone: yup
      .string()
      .required(t.MexicoFormFieldsLabels.commonError)
      .matches(/^\d{10}$/, t.MexicoFormFieldsLabels.phoneInvalid),
    financeAmt: yup.string().required(t.MexicoFormFieldsLabels.commonError),
    CountryCode: yup.string().required(t.MexicoFormFieldsLabels.commonError).notOneOf(["",null],t.MexicoFormFieldsLabels.commonError),
    CompanyType: yup.string().required(t.MexicoFormFieldsLabels.commonError),
  });
};

const USForm = () => {
  const router = useRouter();
  const { locale } = router;
  const t = (locale === "es-mx" && esMX) || (locale === "en-us" && enUS);
  const validationSchema = schema(t);
  const [ThankyouRes, setThankyouRes] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [errMSG, setErrMSG] = useState(false);
  const formType = "MexicoForm";
  const {
    register,
    handleSubmit,
    formState: { isValid, errors },
    reset
  } = useForm({
    mode: "all",
    resolver: yupResolver(validationSchema),
  });

  const handleCaptchaSubmit = useCallback(
    (values) => {
      if (!executeRecaptcha) {
        return false;
      }
      executeRecaptcha().then((gReCaptchaToken) => {
        onFormSubmit(values, gReCaptchaToken);
      });
    },
    [executeRecaptcha]
  );
  // async function onFormSubmit(values) {
  async function onFormSubmit(values,gReCaptchaToken) {
    const body = {
      formType: formType,
      company: values.Company,
      email: values.Email,
      phoneNumber: values.Phone,
      financeRequirement: values.financeAmt,
      countryCode: values.CountryCode,
      companyType: values.CompanyType,
      sourceUrl: window.location.href,
    };
    let config = {
      method: "post",
      url: ENDPOINTS.MEXICO_CONTACT_US,
      headers: {
        "Content-Type": "application/json",
        "g-recaptcha-response": gReCaptchaToken,
      },
      data: body,
    };

    try {
      const response = await axios(config);
      if (response.status == 200) {
        setThankyouRes(true);
        gtag("event", "getFinanceES", {
          event_category: "Get financed ",
          event_label: "Get financed ",
        });
        window.dataLayer.push({
          event: "Mexicoconversion",
          Conversion_ID: "16468312892",
          Conversion_labels: "MIX0CL7dyt0ZELyG2qw9",
        });
        
        setTimeout(() => {
          reset();
          router.push('/thankyou-response')
          setThankyouRes(false);
        }, 5000);
        
      }
    } catch (err) {
      setErrMSG(true);
      console.log("error", err);
      setTimeout(() => {
        reset();
        // window.location.reload();
      }, 5000);
    }
  }

  return (
    <div className="bg-white rounded-[15px] py-4 pb-6 px-5 sm:px-2 lg:w-full lg:max-w-[450px] md:max-w-[400px] mx-auto md:relative md:m-auto md:mb-[20px]">
      <h3 className="text-base2 text-secondary mb-2">
        {t.MexicoFormFieldsLabels.heading1}
        <span className="text-brand font-medium">
          {" "}
          {t.MexicoFormFieldsLabels.heading2}
        </span>
      </h3>

      <div className="border border-bordercolor rounded-md p-2 sm:p-1">
        <form onSubmit={handleSubmit(handleCaptchaSubmit)} className="w-full">
          <div className="part-1">
            <div>
              <label className="text-sm font-medium text-secondary mt-1">
                {t.MexicoFormFieldsLabels.emailLabel}
              </label>
              <input
                {...register("Email")}
                id="email"
                type="email"
                placeholder={t.MexicoFormFieldsLabels.emailPlaceholder}
                autoComplete="email"
                className="block w-full min-w-0 text-xs flex-1 pl-1 h-[35px] rounded-md border-0 py-1.5 ring-1 ring-inset ring-bordercolor focus:ring-[#555] focus:outline-none mt-0.5"
              />
              <p className="text-progressColor4 text-xs mt-[3px]">
                {errors.Email?.message}
              </p>
            </div>
            
           
            
            <div className="flex items-start gap-x-xsp w-full">
              <div className="w-[44%] mt-1">
                <label className="text-sm font-medium text-secondary block mb-[1px]">
                  {t.MexicoFormFieldsLabels.countrycodeLabel}
                </label>
                <div className="relative">
                  <select
                  defaultValue={t.MexicoFormFieldsLabels.countrycodePlaceholder}
                    {...register("CountryCode")}
                    id="code"
                    className="block w-full appearance-none rounded-md border h-[35px] border-bordercolor pl-[5px] placeholder-gray-400 font-normal cursor-pointer bg-white text-xs sm:text-xxs"
                  >
                    {/* <option value="" disabled selected>
                      {t.MexicoFormFieldsLabels.countrycodePlaceholder}
                    </option> */}
                    {t.MexicoFormFieldsLabels.countrycodeData.map((item) => (
                      <option key={item.id} value={item.code}>
                        {item.Showname}
                      </option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-0.5 flex items-center pointer-events-none">
                    <svg
                      className="w-3 sm:w-2 h-3 text-gray-400"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4 4a.75.75 0 01-1.06 0l-4-4a.75.75 0 01.02-1.06z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                </div>
                {errors.CountryCode && (
                <p className="text-progressColor4 text-xs mt-0.5">
                {errors.CountryCode?.message}
                </p>
                )}
              </div>
              <div className="w-[56%] mt-1">
               
                <label className="text-sm font-medium block text-secondary">
                {t.MexicoFormFieldsLabels.phoneLabel}
              </label>
              <input
                {...register("Phone")}
                id="tel"
                type="tel"
                placeholder={t.MexicoFormFieldsLabels.phonePlaceholder}
                className="block w-full min-w-0 text-xs flex-1 pl-1 h-[35px] rounded-md border-0 py-1.5 ring-1 ring-inset ring-bordercolor focus:ring-[#555] focus:outline-none mt-0.5"
              />
               <p className="text-progressColor4 text-xs mt-[3px]">
              {errors.Phone?.message}
            </p>
              </div>
              
            </div>
            {/* Company Name starts*/}
            <div className="mt-1">
              <label className="text-sm font-medium text-secondary mt-1">
                {t.MexicoFormFieldsLabels.companyLabel}
              </label>
              <input
                {...register("Company")}
                type="text"
                id="company"
                placeholder={t.MexicoFormFieldsLabels.companyPlaceholder}
                className="block w-full min-w-0 text-xs flex-1 pl-1 rounded-md h-[35px]  border-0 py-1.5 ring-1 ring-inset ring-bordercolor focus:ring-[#555] focus:outline-none mt-0.5"
              />
              <p className="text-progressColor4 text-xs mt-[3px]">
                {errors.Company?.message}
              </p>
            </div>
            {/* Company Name End*/}
            <div className="mt-1">
              <label className="text-sm font-medium text-secondary">
                  {t.MexicoFormFieldsLabels.companytypeLabel}
                </label>
                <input
                {...register("CompanyType")}
                type="text"
                id="company"
                placeholder={t.MexicoFormFieldsLabels.companytypePlaceholder}
                className="block w-full min-w-0 text-xs flex-1 pl-1  sm:pl-[5px] rounded-md h-[35px]  border-0 py-1.5 ring-1 ring-inset ring-bordercolor focus:ring-[#555] focus:outline-none"
               />
                {errors.CompanyType && (
                <p className="text-progressColor4 text-xs mt-0.5">
                {errors.CompanyType?.message}
                </p>
                )}
            </div>
            <div className="mt-1">
              <label className="text-sm font-medium text-secondary">
                {t.MexicoFormFieldsLabels.financeLabel}
              </label>
              <div className="flex rounded-md  mt-0.5">
                <input
                  value="USD"
                  name="currency"
                  readOnly
                  className="inline-flex w-[70px] justify-center text-sm items-center h-[35px] rounded-l-md border border-bordercolor border-r-0 px-2 text-gray-500"
                />
                <input
                  {...register("financeAmt")}
                  id="financeAmt"
                  type="tel"
                  placeholder={t.MexicoFormFieldsLabels.financePlaceholder}
                  className="block w-full min-w-0 text-xs flex-1 pl-1 rounded-none h-[35px] rounded-r-md border-0 py-1.5 ring-1 ring-inset ring-bordercolor focus:ring-[#555] focus:outline-none"
                />
              </div>
              <p className="text-progressColor4 text-xs mt-[3px]">
                {errors.financeAmt?.message}
              </p>
            </div>
          </div>
          <div className="mt-4">
            <button
              type="submit"
              className="py-1 px-3 rounded-md text-white text-sm w-full bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]"
            >
              {t.MexicoFormFieldsLabels.submit}
            </button>
          </div>
        </form>
        {ThankyouRes ? (
          <>
            <div className="text-green text-center">
              <p className="text-sm font-medium mt-3">
                {t.MexicoFormFieldsLabels.successMsg}
              </p>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default USForm;
